import React from 'react';

function Cloud({ className }: { className: string }) {
  return (
    <g className={className}>
      <path
        d="M11.3339 11.2432C14.4124 11.2432 16.9081 8.74753 16.9081 5.669C16.9081 2.59048 14.4124 0.0948486 11.3339 0.0948486C8.2554 0.0948486 5.75977 2.59048 5.75977 5.669C5.75977 8.74753 8.2554 11.2432 11.3339 11.2432Z"
        fill="white"
      />
      <path
        d="M19.1929 9.65054C21.8316 9.65054 23.9707 7.51143 23.9707 4.8727C23.9707 2.23396 21.8316 0.0948486 19.1929 0.0948486C16.5542 0.0948486 14.415 2.23396 14.415 4.8727C14.415 7.51143 16.5542 9.65054 19.1929 9.65054Z"
        fill="white"
      />
      <path
        d="M5.55823 15.0182C8.62795 15.0182 11.1165 12.6533 11.1165 9.73603C11.1165 6.81877 8.62795 4.45386 5.55823 4.45386C2.4885 4.45386 0 6.81877 0 9.73603C0 12.6533 2.4885 15.0182 5.55823 15.0182Z"
        fill="white"
      />
      <path
        d="M11.5994 17.3875C14.8245 17.3875 17.4389 15.0226 17.4389 12.1053C17.4389 9.18803 14.8245 6.82312 11.5994 6.82312C8.37424 6.82312 5.75977 9.18803 5.75977 12.1053C5.75977 15.0226 8.37424 17.3875 11.5994 17.3875Z"
        fill="white"
      />
      <path
        d="M18.3259 17.3875C21.551 17.3875 24.1655 15.0226 24.1655 12.1053C24.1655 9.18803 21.551 6.82312 18.3259 6.82312C15.1008 6.82312 12.4863 9.18803 12.4863 12.1053C12.4863 15.0226 15.1008 17.3875 18.3259 17.3875Z"
        fill="white"
      />
      <path
        d="M23.349 15.0182C26.7266 15.0182 29.4647 12.6533 29.4647 9.73603C29.4647 6.81877 26.7266 4.45386 23.349 4.45386C19.9715 4.45386 17.2334 6.81877 17.2334 9.73603C17.2334 12.6533 19.9715 15.0182 23.349 15.0182Z"
        fill="white"
      />
    </g>
  );
}

export default Cloud;
